<template>
  <v-layout column>
    <h2 class="primary--text headline font-weight-light">Štítky</h2>
    <v-layout wrap>
      <recipe-tag v-for="(tag, index) in tags" :key="index" :value="tag" />
      <v-flex mt-1 v-if="!tags.length"> {{ emptyText }} </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import RecipeTag from "@/components/RecipeTag";
export default {
  name: "RecipeTags",
  components: { RecipeTag },
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    emptyText: {
      type: String,
      default: "Žádné štítky"
    }
  }
};
</script>
